import type { MutationHookOptions } from "@apollo/client";
import { useMutation, gql } from "@apollo/client";

const AuthenticateWellevatePractitioner_UnauthenticatedWellevateAuthorize_Mutation = gql`
  mutation AuthenticateWellevatePractitioner_UnauthenticatedWellevateAuthorize_Mutation(
    $input: AuthenticateWellevatePractitionerInput!
  ) {
    auth {
      authenticateWellevatePractitioner(input: $input) {
        practitionerId
        email
        firstname
        lastname
        dispensaryName
        fullscriptPractitionerType {
          id
          description
        }
        errors {
          message
        }
      }
    }
  }
`;

interface AuthenticateWellevatePractitionerData {
  auth: {
    authenticateWellevatePractitioner: {
      practitionerId: string;
      email: string;
      firstname: string;
      lastname: string;
      dispensaryName: string;
      fullscriptPractitionerType: {
        id: string;
        description: string;
      };
      errors: {
        message: string;
      };
    };
  };
}

interface Variables {
  input: {
    attributes: {
      email: string;
      password: string;
    };
    captchaToken: string;
  };
}

const useAuthenticateWellevatePractitionerMutation = (
  options?: MutationHookOptions<AuthenticateWellevatePractitionerData, Variables>
) =>
  useMutation(
    AuthenticateWellevatePractitioner_UnauthenticatedWellevateAuthorize_Mutation,
    options
  );

export type { AuthenticateWellevatePractitionerData };
export {
  useAuthenticateWellevatePractitionerMutation,
  AuthenticateWellevatePractitioner_UnauthenticatedWellevateAuthorize_Mutation,
};
